<template>
  <header
    id="header-top"
    class="module-top"
    v-if="showTop && !inMinProgram"
    v-bind:class="{ isBorderBottom: isBorderBottom }"
    v-bind:style="{ backgroundColor: bgColor }"
  >
    <div class="module-top-left">
      <div class="icon-fanhui" @click="back">
        <img src="../../../assets/images/icon_arr_l@3x.png" />
      </div>
      <div v-if="isHomeShow" class="iconfont icon-store" @click="home"></div>
    </div>
    <div class="module-top-title">{{ title | slice }}</div>
    <div class="module-top-right" :style="modRightStyle">
      <slot name="mod-right"></slot>
    </div>
  </header>
</template>
<script>
export default {
  mounted() {
    //            setTimeout(() => this.$$box.alert(document.cookie), 1000);
    this.showTop = !['android', 'ios'].filter(
      device => this.$$getDevice() === device
    ).length
    const $top = document.querySelector('#header-top')
    if (!$top || !this.opacity) return
    window.addEventListener(
      'scroll',
      () => {
        const opacity = 20 / (window.scrollY || document.body.scrollTop)
        $top.style.opacity = opacity > 0.2 ? opacity : 0
      },
      false
    )
  },
  props: {
    title: {
      type: String,
      default: '加载中'
    },
    opacity: {
      type: Boolean,
      default: false
    },
    isPop: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    isHomeShow: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: '#fff'
    },
    isBorderBottom: {
      type: Boolean,
      default: true
    },
    isShowModRight: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    slice(val) {
      return val.length > 12 ? `${val.slice(0, 12)}...` : val
    }
  },
  methods: {
    back() {
      this.$emit('back')
      if (!this.isPop) {
        this.$router.back()
      }
    },
    home() {
      this.$router.push('/home')
    }
  },
  data() {
    return {
      showTop: false
    }
  },
  computed: {
    inMinProgram() {
      return this.$store.state.inMinProgram
    },
    isMiniProgram() {
      return this.$store.state.isMiniProgram
    },
    modRightStyle() {
      return {
        visibility: this.isShowModRight ? 'visible' : 'hidden'
      }
    }
  }
}
</script>
<style lang="scss" scoped rel="stylesheet/scss">
@import '../../../assets/css/mixin';
.module-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: rem(80px);
  padding: 0 rem(20px);
  /*position: fixed;*/
  top: 0;
  left: 0;
  z-index: 201;
  /*background: #fff;*/
  font-size: rem(36px);
  &.isBorderBottom {
    @include border(bottom);
  }
  & + * {
    /*padding-top: rem(80px);*/
  }
  &-left {
  }
  &-right {
    visibility: hidden;
  }
}
.module-top-left {
  display: flex;
  width: rem(100px);
}
.icon-fanhui {
  margin-right: rem(20px);
  img {
    width: rem(27px);
  }
}
.icon-store {
  color: #999;
  width: rem(60px);
  text-align: center;
}
.module-top-right {
  width: rem(100px);
}
</style>
